import React from 'react';
import {Platform} from 'react-native';
import Modal, {ModalProps} from 'react-native-modal';
import {ModalPortal} from './ModalHost';

export type OverlayModalProps = Partial<ModalProps> & {
  isVisible: boolean;
  children: React.ReactNode;
};
const nativeDriver = Platform.OS !== 'web';

export function OverlayModal(props: OverlayModalProps) {
  return (
    <ModalPortal>
      <Modal
        useNativeDriver={nativeDriver}
        useNativeDriverForBackdrop={nativeDriver}
        {...props}
        coverScreen={false}
      />
    </ModalPortal>
  );
}
